import { Row, Table } from "antd";
import { useTableColumns } from "../hooks/useTableColumns";
import { useCallback, useMemo } from "react";
import { IPayeeDisbursementsBase } from "../../../../../../types/PayeeDisbursements";

type DisbursementsTableProps = {
  disbursements: IPayeeDisbursementsBase[];
  isFormDisabled: boolean;
  isPaymentPosted: boolean;
  openDeleteModal: (id: string) => void;
  onOpenSideBar: (value: any) => void;
};

export const DisbursementsTable = ({
  disbursements,
  isFormDisabled,
  isPaymentPosted,
  openDeleteModal,
  onOpenSideBar,
}: DisbursementsTableProps) => {
  const { columns } = useTableColumns(
    isFormDisabled,
    isPaymentPosted,
    openDeleteModal,
    onOpenSideBar
  );

  const onRow = useCallback(
    (record: IPayeeDisbursementsBase) => ({
      onClick: () => onOpenSideBar(record),
    }),
    [onOpenSideBar]
  );

  const paginationProps: false | any = useMemo(() => {
    return disbursements.length <= 10
      ? false
      : {
          size: "small",
        };
  }, [disbursements]);

  return (
    <Row className="w-100">
      <Table
        dataSource={disbursements}
        columns={columns}
        pagination={paginationProps}
        rowKey="index"
        showHeader={false}
        expandable={{ showExpandColumn: false }}
        className="w-100 payment-disb-table mb-4 clickable-rows-table"
        onRow={onRow}
      />
    </Row>
  );
};
